import styled from "styled-components";

export const Container= styled.main`
    height: 100%;
    width: 100%;
    background-color: ${props=> props.theme.colors.brand4.pure};
    padding: 40px 0;
`

export const WishlistContent = styled.div `
    width: 95%;
    margin: 0 auto;
    
    @media(min-width: 768px) {
        width: 60%;
       } 
`